import * as React from 'react';

import { Loading } from 'common/components/Loading';

export interface DialogStatusProps {
  isLoading?: boolean;
  loadingMessage?: string;
  error?: string;
  success?: string;
}
export const DialogStatus: React.SFC<DialogStatusProps> = (props: DialogStatusProps) => {
  if (!props.isLoading && !props.error && !props.success) {
    return <span />;
  }
  return (
    <div>
      {props.isLoading && (
        <div style={{ margin: 10 }}>
          <Loading message={props.loadingMessage ? props.loadingMessage : 'Please wait...'} />
        </div>
      )}
      {props.error && (
        <div className="alert alert-danger" style={{ margin: 10 }}>
          {props.error}
        </div>
      )}
      {props.success && (
        <div className="alert alert-success" style={{ margin: 10 }}>
          {props.success}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/dialogs/DialogStatus.tsx